<template>
    <div class="text-a-brown-502314">
        <div class="pt-3 font-bold">{{lbl.shoppingcart.additional_message}}</div>
        <div class="flex w-full py-2">
            <img class="ml-0 mr-1" src="@/assets/icon/ic-cutlery-brown.svg"/>
            <div class="text-14 my-auto">{{lbl.shoppingcart.cutlery}}</div>
            <img class="ml-auto mr-0 cursor-pointer" v-if="PlaceOrderStore.state.placeOrder.doNotNeedPlastic" @click="clickNeedPlastic()" src="@/assets/image/button-off-brown.svg"/>
            <img class="ml-auto mr-0 cursor-pointer" v-if="!PlaceOrderStore.state.placeOrder.doNotNeedPlastic" @click="clickNeedPlastic()" src="@/assets/image/button-on-brown.svg"/>
        </div>
        <div class="flex w-full pt-2 pb-4">
            <img class="ml-0 mr-1" src="@/assets/icon/ic-sauce-brown.svg"/>
            <div class="text-14 my-auto">{{lbl.shoppingcart.sauce}}</div>
            <img class="ml-auto mr-0 cursor-pointer" v-if="PlaceOrderStore.state.placeOrder.doNotNeedSauce" @click="clickSauce()" src="@/assets/image/button-off-brown.svg"/>
            <img class="ml-auto mr-0 cursor-pointer" v-if="!PlaceOrderStore.state.placeOrder.doNotNeedSauce" @click="clickSauce()" src="@/assets/image/button-on-brown.svg"/>
        </div>
        <div class="pb-3">
            <textarea v-model="PlaceOrderStore.state.placeOrder.userRemark"
                class="w-full bg-white placeholder-a-brown-bba596 rounded-xl p-2 text-14 text-a-brown-502314 border-a-brown-d7c7b8 border"
                :placeholder="lbl.shoppingcart.type_your_request"
                rows="3"
            ></textarea>
        </div>
    </div>
</template>

<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: "CartAdditional",
    mixins: [LocaleMixin],
    inject: ['PlaceOrderStore'],
    data: function() {
        return {
            requestMessage: ''
        };
    },
    methods: {
        clickSauce: function() {
            this.PlaceOrderStore.state.placeOrder.doNotNeedSauce = !this.PlaceOrderStore.state.placeOrder.doNotNeedSauce;
        
            if (this.PlaceOrderStore.state.placeOrder.doNotNeedSauce) {
                this.tracking.event('shopping_bag','click_sauce', 'get_the_sauce', null);
            } else {
                this.tracking.event('shopping_bag','click_sauce', 'no sauce', null);
            }

        },
        clickNeedPlastic: function() {
            
            this.PlaceOrderStore.state.placeOrder.doNotNeedPlastic = !this.PlaceOrderStore.state.placeOrder.doNotNeedPlastic;
            
            if (this.PlaceOrderStore.state.placeOrder.doNotNeedPlastic) {
                this.tracking.event('shopping_bag','click_cutlery', 'get_the_cutlery', null);
            } else {
                this.tracking.event('shopping_bag','click_cutlery', 'no cutlery', null);
            }
            
        }
    }
}
</script>

<style>

</style>